import { Link } from "react-router-dom";
// import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import "./Foot.css";

const Foot = () => {
  return (
    <footer className="footer">
      <div className="footer-grid">

        {/* Left: Logo + Motivational Description + Socials */}
        <div className="footer-card">
          <div className="footer-logo">
            <div className="footer-logo-circle">S</div>
            <span className="footer-title">SarvSahayataSangathan</span>
          </div>
          <p className="footer-desc">
            Be a hero every day. Donate blood, save lives, and inspire hope for those in need.
          </p>
          {/* <div className="footer-socials">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaTwitter /></a>
            <a href="#"><FaLinkedinIn /></a>
          </div> */}
        </div>

        {/* Center: Quick Links + Support + Tagline */}
        <div className="footer-card">
          <h3>Quick Links</h3>
          <ul className="footer-links-grid">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/support">Support & Case</Link></li>
            <li><Link to="/legal">Legal Identity</Link></li>
          </ul>
          <h3>Support</h3>
          <ul>
            <li><a href="#contactus-form">Contact Us</a></li>
            {/* <li><Link to="/faq">FAQs</Link></li> */}
          </ul>
          <p className="footer-small-desc">
            Together we can save lives and spread awareness about blood donation.
          </p>
        </div>

        {/* Right: Map + Address */}
        <div className="footer-card">
          <h3>Our Location</h3>
          <iframe
            title="SarvSahayataSangathan"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3443.556887943811!2d76.97615827503696!3d31.202665481495515!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfc374abf88b1%3A0x9a64b57450a9f688!2sBaddi%2C%20Himachal%20Pradesh%20173205!5e0!3m2!1sen!2sin!4v1692618622063!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
          <div className="footer-address">
            <p>Om Sai Complex</p>
            <p>Post Office Karuana Sai Road</p>
            <p>Gullarwala, Baddi-173205</p>
            <p><a href="mailto:Sarvsahayatasangathan@gmail.com">sarvsahayatasangathan@gmail.com</a></p>
            <p><a href="tel:+919318781506">+91-93187 81506</a></p>
            <p><a href="tel:+91931783125">+91-93178 03125</a></p>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} SarvSahayataSangathan. All rights reserved.
      </div>
    </footer>
  );
};

export default Foot;
